import React, { useEffect, useState } from 'react'
import { Tune, KeyboardArrowDown, KeyboardArrowRight, Sort, Close, KeyboardArrowUp, ArrowUpward, ArrowDownward, KeyboardArrowLeft, ArrowLeft, ArrowRight } from '@mui/icons-material'
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"
import ProductTiles from '../components/ProductTiles'
import Addproduct from '../components/Addproduct'
import axios from 'axios'
import { Url } from '../services/Constants'
import { Getauth } from '../services/Auth'
import { setHeader } from '../services/Headers'
import { GetUserRole } from '../services/UserRole'
import { useNavigate } from 'react-router-dom'
import SellerOrderTiles from '../components/SellerOrderTiles'

export default function SellersOrders() {

    const Navigate = useNavigate()
    const [sort, setSort] = useState(false)
    const [filter, setFilter] = useState(false)
    const [category, setCategory] = useState(false)
    const [order, setOrder] = useState(false)
    const [varient, setVarient] = useState(false)
    const [type, setType] = useState(false)
    const [addproductActive, setAddproductActive] = useState(false)
    const [isSeller, setIsseller] = useState(false)
    const [categoryName, setCategoryName] = useState("All Products");
    const [sortCriteria, setSortCriteria] = useState('newest');
    const navigate = useNavigate();
    const [variant, setVariant] = useState(false);
    const [showMobileFilters, setShowMobileFilters] = useState(false);
    const [products, setProducts] = useState([]);
    const [userRole, setUserRole] = useState(GetUserRole());

    useEffect(() => {


        const userProfileCheck = async () => {
            if (GetUserRole() == "seller") {
                try {
                    const result = await axios.get(`${Url}/seller/get_profile`, setHeader())
                    const data = result.data.response_code;
                    if (data === 200) {
                        setIsseller(true)
                    }else{
                        Navigate("/")
                    }

                } catch (error) {
                    console.log(error)
                }
            }else{
                Navigate("/")
            }

        }

        userProfileCheck()
    }, [])

    const getCategoryName = (data) => {
        setCategoryName(data)
    }

    const sortHandle = () => {
        setSort(!sort)
        let sortClass
    }

    const addProductToggle = () => {
        setAddproductActive(!addproductActive)
    }


    const handleSortChange = (criteria) => {
        setSortCriteria(criteria);
        setSort(false);
    };


    const toggleDropdown = (type) => {
        if (type === 'category') setCategory(!category);
        if (type === 'variant') setVariant(!variant);
        if (type === 'order') setOrder(!order);
    };

    const fetchRecentOrders = async () => {
        try {
            let url = `${Url}/seller/recent_orders`;

            // Add sort query parameters
            if (sortCriteria === 'latest') {
                url += '?isLatest=true';
            } else if (sortCriteria === 'oldest') {
                url += '?isLatest=false';
            }

            const response = await axios.get(url, setHeader());
            const recentOrders = response.data.response_data.recent_orders;

            // Filter based on variants
            let filteredProducts = recentOrders;

            setProducts(filteredProducts);
        } catch (error) {
            console.error("Error fetching recent orders:", error);
        }
    };

    useEffect(() => {
        fetchRecentOrders();
    }, [sortCriteria]);

    return (

            <div className="sellerorders-container flex flex-col min-h-screen ">
                <div className="products-header fixed top-0 z-10 w-full">
                    <Navbar />
                </div>
                <div className="products-feed mt-24 flex-1">
                    <div className="flex flex-col md:flex-row">
                        {/* Mobile Filter Button */}
                        <div className="md:hidden mb-4 mx-auto">
                            <button
                                className="w-full text-white font-bold text-lg bg-amber-950 rounded-md p-2"
                                onClick={() => setShowMobileFilters(!showMobileFilters)}
                            >
                                {showMobileFilters ? 'Hide Filters' : 'Show Filters'}
                            </button>
                        </div>

                        {/* Sidebar for Filters */}
                        <div className={`filter-container md:w-1/4 p-2  ${showMobileFilters ? 'block' : 'hidden md:block'}`} style={{ marginBottom: '0' }}>
                            <div className=" p-2 bg-white rounded-lg shadow-md">
                                <h2 className="text-lg font-bold text-brown-700 mb-4">Filters</h2>

                                {/* PRICE RANGE */}
                                <div className="mb-4">
                                    <h3
                                        className="flex items-center justify-between text-sm font-semibold text-gray-700 cursor-pointer"
                                        onClick={() => toggleDropdown('order')}
                                    >
                                        Orders
                                        {order ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                    </h3>
                                    {order && (
                                        <div className="ml-4 mt-2 space-y-2">
                                            <label className="flex items-center space-x-2">
                                                <input
                                                    type="radio"
                                                    name="orderSort"
                                                    className="h-4 w-4 border-gray-300 rounded"
                                                    onChange={() => handleSortChange('latest')}
                                                />
                                                <span className="text-sm text-gray-600 max-lg:text-xs">Latest orders</span>
                                            </label>
                                            <label className="flex items-center space-x-2">
                                                <input
                                                    type="radio"
                                                    name="orderSort"
                                                    className="h-4 w-4 border-gray-300 rounded"
                                                    onChange={() => handleSortChange('oldest')}
                                                />
                                                <span className="text-sm text-gray-600 max-lg:text-xs">Oldest orders</span>
                                            </label>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Main Content Area */}
                        <div className="order-feed w-[95%] mr-5 max-sm:mx-auto">
                            <div className="grid grid-cols-5 mb-10 gap-3 max-xl:grid-cols-4 max-lg:grid-cols-3 max-sm:grid-cols-1 max-sm:w-[80%] max-sm:mx-auto">
                                {products.map((order) => (
                                    <SellerOrderTiles order={order} key={order.order_id} />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="products-footer  w-full bottom-0">
                    <Footer />
                </div>
            </div>
      
    )
}

